import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { SurveyDetail } from '@liza/ui/components/records/SurveyDetail';
import { formatCodeableConcept } from '@medplum/core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { SurveyResponseContent } from './SurveyResponseContent';

type Props = {
  surveyIdentifier: string;
  medplumPatientId: string;
};

export const SurveyDetailContent = ({ surveyIdentifier, medplumPatientId }: Props): React.ReactNode => {
  const { t } = useTranslation('common');
  const trpc = useTRPC();

  const observationsQuery = useQuery(
    trpc.patient.observation.list.queryOptions({
      category: 'surveys',
      medplumPatientId,
      options: { status: 'active', searchParams: { code: surveyIdentifier, _count: 100, _offset: 0 } },
    }),
  );

  const surveysForIdentifier = observationsQuery.data?.observations ?? [];

  return (
    <QueryStateHandler query={observationsQuery} emptyMessage={t('noRecordsAvailable')}>
      {() => {
        if (surveysForIdentifier.length === 0) return <p className="p-4">{t('surveyNotFound')}</p>;
        const surveyName = formatCodeableConcept(surveysForIdentifier.at(0)?.code);
        return (
          <SurveyDetail
            surveyName={surveyName}
            results={surveysForIdentifier}
            renderResponse={(result) => <SurveyResponseContent observation={result} />}
          />
        );
      }}
    </QueryStateHandler>
  );
};
